module.exports = __webpack_public_path__ + "img/ampi.df99b70d.png";